<template>
  <v-container fluid>
    <grupos-arquivos-data-table
      :items="items"
      @rechargeTable="getAllGruposArquivos()"
    />
  </v-container>
</template>

<script>

import GruposArquivosService from '@/services/GruposArquivosService.js';

export default {
  name: "GruposArquivosIndex",

  components: {
    GruposArquivosDataTable: () => import("@/components/gruposArquivos/GruposArquivosDataTable.vue"),
  },

  data() {
    return {
      items: [],
    }
  },

  mounted() {
    this.getAllGruposArquivos();
  },

  methods: {
    getAllGruposArquivos() {
      GruposArquivosService.getAllGruposArquivos()
        .then(res => {
          this.items = [];

          res.data.grupos.forEach(element => {
            this.items.push({
              id: element.id,
              nome: element.grupo,
              dia_envio: element.dia_envio,
              num_arquivos: Object.values(element.arquivos).length,
              ativo: element.status,
              criado_por: element.usuario.nome
            });
          });
        })
        .catch(err => {
          this.$toast.error("Erro ao Grupos de Arquivos.", "", { position: "topRight"});
          console.error(err);
        });
    },
  }
  
}

</script>